export const ADD_COLOR = "ADD_COLOR";
export const MERGE_COLORS = "MERGE_COLORS";
export const RESET_COLOR = "RESET_COLOR";
export const REMOVE_COLOR = "REMOVE_COLOR";
export const SELECT_COLOR = "SELECT_COLOR";
